<template>
  <form v-loading="loading" @submit.prevent="save">
    <b-modal ref="modal" :visible="true" :title="title" @hide="close">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Plan Name") }}</label>
            <input
              v-model="model.planName"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Short Description") }}</label>
            <textarea
              v-model="model.description"
              type="text"
              class="form-control"
              required
              rows="3"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Price", 1) }}</label>
            <input
              v-model="model.price"
              type="number"
              class="form-control"
              required
              min="0"
              step="any"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="form-group">
              <label>{{ $t("Currency") }}</label>
              <select v-model="model.currency" class="form-control">
                <option
                  v-for="(currency, currencyKey) in currencies"
                  :key="currencyKey"
                  :value="currency.value"
                >
                  {{ currency.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Products", 2) }}</label>
            <input
              v-model="model.products"
              type="number"
              class="form-control"
              required
              min="0"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Users", 2) }}</label>
            <input
              v-model="model.users"
              type="number"
              class="form-control"
              required
              min="0"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Stores and Marketplaces", 2) }}</label>
            <input
              v-model="model.marketplaces"
              type="number"
              class="form-control"
              required
            />
          </div>
        </div> -->
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Orders", 2) }}</label>
            <input
              v-model="model.orders"
              type="number"
              class="form-control"
              required
              min="0"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("SKUs", 2) }}</label>
            <input
              v-model="model.skus"
              type="number"
              class="form-control"
              required
              min="0"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Plan Id") }}</label>
            <input
              v-model="model.planId"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Product Id") }}</label>
            <input
              v-model="model.productId"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
      </div> -->
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Features") }}</label>
            <textarea
              v-model="model.features"
              type="text"
              class="form-control"
              required
              rows="4"
              placeholder="Comma separated features"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Discount", 1) }}</label>
            <input
              v-model="model.discount"
              type="number"
              class="form-control"
              required
            />
          </div>
        </div> -->
        <div class="col-6">
          <div class="form-group">
            <label>{{ $t("Interval") }}</label>
            <select v-model="model.interval" class="form-control" disabled>
              <option
                v-for="(interval, intervalKey) in intervals"
                :key="intervalKey"
                :value="interval.value"
              >
                {{ interval.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>{{ $t("Accounts") }}</label>
             <multiselect 
              v-model="model.account_id"
              :id="'id'"
              :value="'id'"
              :placeholder="$t('Type to search object', {object: $t('Account')})"
              :label="'name'"
              :track-by="'id'"
              :multiple="multiple"
              :options="accounts"
             />
            <!-- <select v-model="model.account_id" class="form-control" multiple>
              <option
                v-for="(account, accountKey) in accounts"
                :key="accountKey"
                :value="account.id"
                :selected="accounts.filter((item) => item.id === model.account_id).length > 0"
              >
                {{ account.name }}
              </option>
            </select> -->
          </div>
        </div>
      </div>

      <!-- <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.recurring"
          type="checkbox"
        />
        <label for="account-create-form-enabled">{{ $t("Recurring") }}?</label>
      </div> -->
      <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.popular"
          type="checkbox"
        />
        <label for="account-create-form-enabled">{{ $t("Popular") }}?</label>
      </div>
      <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.enabled"
          type="checkbox"
        />
        <label for="account-create-form-enabled">{{ $t("Active") }}?</label>
      </div>
      <template slot="modal-footer">
        <button type="submit" class="btn btn-primary">
          {{ $t("Save") }}
        </button>
        <button type="button" class="btn btn-secondary" @click.prevent="close">
          {{ $t("Close") }}
        </button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import PlanModel from "../models/PlanModel";
import PlanService from "../services/PlansService";
import ApiService from "../services/ApiService";
export default {
  name: "AppPagePlanEdit",
  components: {
    Multiselect,
  },
  data() {
    return {
      model: PlanModel.getDefaults(),
      loading: true,
      intervals: [
        { value: "year", name: "Yearly" },
        { value: "month", name: "Monthly" },
      ],
      currencies: [
        { value: "usd", name: "USD" },
      ],
      accounts: [],
      value:[],
      multiple:true
    };
  },
  computed: {
    title() {
      if (this.model.id === 0) {
        return this.$t("Loading");
      }
      return `${this.$tc("Plans", 1)} ID: ${this.model.id}`;
    },
    planId() {
      return parseInt(this.$route.params.id, 10);
    },
  },
  mounted() {
    this.load();
    this.getAccounts();
  },
  methods: {
    load() {
      PlanService.findById(this.planId)
        .then((data) => {
          this.model = PlanModel.fromApiResponse(data);
          this.loading = false;
        })
        .catch(() => {
          this.$errors_showNetworkErrorMessage();
          this.close();
        });
    },
    getAccounts() {
      ApiService.request("GET", "accounts", {})
        .then((response) => {
          if (response.status === 200) {
            this.accounts = response.data;
          } else {
            console.log("error");
          }
        })
        .catch(() => {
          console.log("error");
        });
    },
    save() {
      this.loading = true;
      this.model.is_default = false;
      // this.model.features = this.model.features.split(",");
      const data = PlanModel.toApiRequest(this.model);
      data.account_id =  data.account_id.map(v => v.id);
      PlanService.update(this.planId, data)
        .then(() => {
          this.$toastr.success(
            this.$t("Action", {
              object: this.$tc("Plans", 1),
              action: this.$t("updated"),
            }),
            this.$t("Success")
          );
          this.loading = false;
        })
        .catch((error) => {
          this.$toastr.error(error.message, this.$t("Error"));
          this.loading = false;
        });
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
